import { queryOptions } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";

export const queryOptions_shift_single = (id: Parameters<typeof api.shift.get>[0]) =>
  queryOptions({
    queryKey: ["shift", id] as const,
    queryFn: (context) =>
      extractionWrapper(api.shift.get(context.queryKey[1], { signal: context.signal })),
  });
